import formGenerator from '../../components/Forms/generators/formGenerator'
import btnsGenerator from '../../components/Forms/generators/users/btnsGenerator'
import {validate} from "../utils/validate";
import errors from '../../components/Forms/errors'
import {mapState,mapGetters,mapMutations} from 'vuex'

export const showMoreMoreUsers = {
  mixins: [validate],
  components: {
    formGenerator,
    errors
  },
  props: {
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      components: [],
    }
  },
  computed: {
    ...mapState({
      users: state => state.users.users,
      editIndex: state => state.users.editUserIndex,
    }),
    ...mapGetters({
      editUser: 'users/editedUser'
    }),
  },
  methods: {
    delOption(indexInner, indexOutter) {
      this.showMoreForm[indexOutter].options.splice(indexInner, 1)
    },
    changeFormItem(val,i) {
      this.components[i].value = val;
      this.updateComponentInput({
        innerIndex: i,
        value: val
      });
    },
    enableEdit() {
      this.$emit('enableEdit')
    }
  },
  beforeMount() {
    if (this.editUser.components) {
      this.components = this.editUser.components
    }
  }
}
